import { Fragment } from 'react';
import computeClassName from '../../../../../utils/computeClassName';
import PartnerRolesAndLevelsEmpty from '../Empty';
import PartnerRolesAndLevelsRoleAndLevel from '../RoleAndLevel';

const constants = Object.freeze({
  CLASSNAME_BASE: 'list-none flex flex-row items-center flex-wrap',
  PARTNER_ROLES_AND_LEVELS_DEFAULT: {}
});

const propsDefaults = Object.freeze({
  partnerRolesAndLevels: constants.PARTNER_ROLES_AND_LEVELS_DEFAULT,
});

export default function PartnerRolesAndLevelsAll({
  partnerRolesAndLevels = propsDefaults.partnerRolesAndLevels,
  className = ''
}) {
  const partnerRolesCount = !!partnerRolesAndLevels && 'object' === typeof partnerRolesAndLevels ? Object.keys(partnerRolesAndLevels).length : 0;
  if(partnerRolesCount > 0) {
    const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
    const isDivided = partnerRolesCount > 1;
    const partnerRoles = Object.keys(partnerRolesAndLevels);
    const partnerLevels = Object.values(partnerRolesAndLevels);
    return isDivided ?
      (
        <ul className={computedClassName}>
          <li>
            {
              partnerRoles.map((partnerRole, index) => {
                if(index < partnerRoles.length - 1 ) {
                  return (
                    <Fragment key={index}>
                      <PartnerRolesAndLevelsRoleAndLevel partnerRole={partnerRole}
                                                         partnerLevel={partnerLevels[index]}/>
                      <span className="mx-1 text-cc-muted-contrast select-none">|</span>
                    </Fragment>
                  );
                } else
                {
                  return (<PartnerRolesAndLevelsRoleAndLevel key={index}
                                                             partnerRole={partnerRole}
                                                             partnerLevel={partnerLevels[index]}/>);
                }
              })
            }
          </li>
        </ul>
      ) :
      <PartnerRolesAndLevelsRoleAndLevel partnerRole={partnerRoles[0]}
                                         partnerLevel={partnerLevels[0]}/>
  }
  else {
    return (
      <div>
        <PartnerRolesAndLevelsEmpty />
      </div>
    );
  }
}
